import { initializeApp } from "firebase/app";

export const firebaseConfig = {
  apiKey: "AIzaSyC814dJz58r7iREk1NsydeGsXkUcfOE_O0",
  authDomain: "fcm-mesaging-hrn.firebaseapp.com",
  projectId: "fcm-mesaging-hrn",
  storageBucket: "fcm-mesaging-hrn.firebasestorage.app",
  messagingSenderId: "380987237589",
  appId: "1:380987237589:web:ee33d04619088a54676e5c",
  measurementId: "G-GLCBTGSQZP",
};

export const app = initializeApp(firebaseConfig);
export const TIME_ZONE = `Asia/Ho_Chi_Minh`;

export const WEB_PUSH_CERTIFITCATION =
  "BN_SiPf066wQGcOFwADhFqMaF_rQkJagckTeuw9Gxo6INyv3Yce0OrURx3-52bE0F7JWI76TWcrFbeOb1k1QjxQ";
export const VERSION = "2.0.0"